export const Colors = {
  ABORTED: 'neutral.main',
  ABORTING: 'neutral.main',
  COMPLETED: 'success.main',
  DELETING: 'warning.main',
  DRAFT: 'neutral.main',
  FAILED: 'error.main',
  PREPARING: 'neutral.main',
  RUNNING: 'status.running',
  SCHEDULED: 'info.main',
  SAVING: 'info.main',
  PARTIALLY_COMPLETED: 'warning.main',
} as Readonly<Record<string, string>>;
